<script setup lang="ts">
import AppContainer from "~/components/ui/AppContainer.vue";
import AppWrapper from "~/components/AppWrapper.vue";
import AppRichText from "~/components/AppRichText.vue";

defineProps({
  content: {
    type: String,
    default: null,
  },
  fullWidth: Boolean,
  hasPadding: Boolean,
  showBackground: Boolean,
  spacingTop: Boolean,
});
</script>

<template>
  <AppContainer class="relative z-10" :spacing-top="spacingTop">
    <AppWrapper
      :class="{
        '3xl:px-8': hasPadding,
      }"
      :container-width="fullWidth ? 'w-full' : 'w-full lg:w-12/14 3xl:w-12/16'"
      :container-max-width="!fullWidth"
      :padding="hasPadding"
    >
      <div
        :class="[
          {
            'bg-interface-transparent-blue p-8 xl:p-12 3xl:p-16':
              showBackground,
          },
        ]"
      >
        <AppRichText v-if="content" :content="content" />
      </div>
    </AppWrapper>
  </AppContainer>
</template>
